<template>
  <div>
    <el-row type="flex" justify="center">
      <el-form ref="modifyForm" :model="modifyForm" label-width="80px">
        <el-form-item label="字段" prop="region">
          <el-select v-model="region" clearable>
            <el-option v-for="item in elLists" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字段内容">
          <el-radio-group v-model="content" @change="contentChange">
            <el-radio label="empty">清空内容</el-radio>
            <el-radio label="edit">修改为新值</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 非常规物料标识 isConventionalMaterials-->
        <el-form-item v-if="region==='isConventionalMaterials'&&isNotEmpty" prop="isConventionalMaterials">
          <el-select v-model="modifyForm.isConventionalMaterials" placeholder="请选择非常规物料标识" clearable>
            <el-option v-for="item in isConventionalMaterialsLists" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- DCs dcs-->
        <el-form-item v-if="region==='dcs'&&isNotEmpty" prop="dcs">
          <el-select class="multiple_sel" style="width:100%" v-model="modifyForm.dcs" clearable multiple filterable placeholder="请选择DCs">
            <el-option :key="index" v-for="(item,index) in dcsLists" :label="item.supplierName" :value="item.tmSupplierId"></el-option>
          </el-select>
        </el-form-item>
        <!-- 是否LTO isLto-->
        <el-form-item v-if="region==='isLto'&&isNotEmpty" prop="isLto">
          <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="modifyForm.isLto" placeholder="请选择是否LTO"></ic-select>
        </el-form-item>
        <!-- 提交审批人 approvedBy-->
        <el-form-item v-if="region==='approvedBy'&&isNotEmpty" prop="approvedBy">
          <el-select v-model="modifyForm.approvedBy" @change="approvedByChange" placeholder="请选择提交审批人" clearable>
            <el-option :key="index" v-for="(item,index) in leaderList" :label="item.userName" :value="item.tmUserId"></el-option>
          </el-select>
          <p style="color:#F56C6C">请根据物料非常规标识和是否LTO选择对应的审批.</p>
        </el-form-item>
        <!-- 结算分类 settlementClassification-->
        <el-form-item v-if="region==='settlementClassification'&&isNotEmpty" prop="settlementClassification">
          <ic-select clearable table="TM_MATERIAL_RECORD" field="SETTLEMENT_CLASSIFICATION" v-model="modifyForm.settlementClassification" placeholder="请选择结算分类"></ic-select>
        </el-form-item>
        <!-- 使用区域 useArea-->
        <el-form-item v-if="region==='useArea'&&isNotEmpty" prop="useArea">
          <ic-select clearable table="TM_MATERIAL_RECORD" field="USE_AREA" v-model="modifyForm.useArea" placeholder="请选择使用区域"></ic-select>
        </el-form-item>
        <!-- 原产地 originCountry-->
        <el-form-item v-if="region==='originCountry'&&isNotEmpty" prop="originCountry">
          <el-input v-model.trim="modifyForm.originCountry" maxlength="10" clearable placeholder="请输入原产地"></el-input>
        </el-form-item>
        <!-- 最小订单量 minimumOrders-->
        <el-form-item v-if="region==='minimumOrders'&&isNotEmpty" prop="minimumOrders">
          <el-input v-model.trim="modifyForm.minimumOrders" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入最小订单量"></el-input>
        </el-form-item>
        <!-- 最小订单单位 minimumOrderUnit-->
        <el-form-item v-if="region==='minimumOrderUnit'&&isNotEmpty" prop="minimumOrderUnit">
          <ic-select clearable table="TM_MATERIAL_RECORD" field="MINIMUM_ORDER_UNIT" v-model="modifyForm.minimumOrderUnit" placeholder="请选择最小订单单位"></ic-select>
        </el-form-item>
        <!-- 是否可追溯 isTraceable-->
        <el-form-item v-if="region==='isTraceable'&&isNotEmpty" prop="isTraceable">
          <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="modifyForm.isTraceable" placeholder="请选择是否可追溯"></ic-select>
        </el-form-item>
        <!-- 是否进入Catellae系统 enterCatellaeSystem-->
        <el-form-item v-if="region==='enterCatellaeSystem'&&isNotEmpty" prop="enterCatellaeSystem">
          <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="modifyForm.enterCatellaeSystem" placeholder="请选择是否进入Catellae系统"></ic-select>
        </el-form-item>
        <!-- 储存环境 temperature-->
        <el-form-item v-if="region==='temperature'&&isNotEmpty" prop="temperature">
          <ic-select clearable table="COMMON" field="TEMPERATURE" v-model="modifyForm.temperature" placeholder="请选择储存环境"></ic-select>
        </el-form-item>
        <!-- 有效期检查 validityDate-->
        <el-form-item v-if="region==='validityDate'&&isNotEmpty" prop="validityDate">
          <ic-select clearable table="TM_MATERIAL_RECORD" field="VALIDITY_DATE" v-model="modifyForm.validityDate" placeholder="请选择有效期检查"></ic-select>
        </el-form-item>
        <!-- 最低保存温度 minimumStorageTemperature-->
        <el-form-item v-if="region==='minimumStorageTemperature'&&isNotEmpty" prop="minimumStorageTemperature">
          <el-input v-model.trim="modifyForm.minimumStorageTemperature" maxLength='10' placeholder="请输入最低保存温度"></el-input>
        </el-form-item>
        <!-- 最高保存温度 maximumStorageTemperature-->
        <el-form-item v-if="region==='maximumStorageTemperature'&&isNotEmpty" prop="maximumStorageTemperature">
          <el-input v-model.trim="modifyForm.maximumStorageTemperature" maxLength='10' placeholder="请输入最高保存温度"></el-input>
        </el-form-item>
        <!-- DC库存管理单位 dcManagementUnit-->
        <el-form-item v-if="region==='dcManagementUnit'&&isNotEmpty" prop="dcManagementUnit">
          <ic-select table="TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="modifyForm.dcManagementUnit" placeholder="请选择DC库存管理单位"></ic-select>
        </el-form-item>
        <!-- 产品外包装类型 productPackagingType-->
        <el-form-item v-if="region==='productPackagingType'&&isNotEmpty" prop="productPackagingType">
          <ic-select table="TM_MATERIAL_RECORD" field="PRODUCT_PACKAGING_TYPE" v-model="modifyForm.productPackagingType" placeholder="请选择产品外包装类型"></ic-select>
        </el-form-item>
        <!-- 产品外包装长度 externalPackagingLength-->
        <el-form-item v-if="region==='externalPackagingLength'&&isNotEmpty" prop="externalPackagingLength">
          <el-input v-model.trim="modifyForm.externalPackagingLength" @blur="modifyForm.externalPackagingLength=onBlur(modifyForm.externalPackagingLength,2)" @keyup.native="modifyForm.externalPackagingLength=onInput(modifyForm.externalPackagingLength)" clearable></el-input>
        </el-form-item>
        <!-- 产品外包装宽度 externalPackagingWidth-->
        <el-form-item v-if="region==='externalPackagingWidth'&&isNotEmpty" prop="externalPackagingWidth">
          <el-input v-model.trim="modifyForm.externalPackagingWidth" @blur="modifyForm.externalPackagingWidth=onBlur(modifyForm.externalPackagingWidth,2)" @keyup.native="modifyForm.externalPackagingWidth=onInput(modifyForm.externalPackagingWidth)" clearable></el-input>
        </el-form-item>
        <!-- 产品外包装高度 externalPackagingHeight-->
        <el-form-item v-if="region==='externalPackagingHeight'&&isNotEmpty" prop="externalPackagingHeight">
          <el-input v-model.trim="modifyForm.externalPackagingHeight" @blur="modifyForm.externalPackagingHeight=onBlur(modifyForm.externalPackagingHeight,2)" @keyup.native="modifyForm.externalPackagingHeight=onInput(modifyForm.externalPackagingHeight)" clearable></el-input>
        </el-form-item>
        <!-- 产品外包装净重 externalPackagingNetweight-->
        <el-form-item v-if="region==='externalPackagingNetweight'&&isNotEmpty" prop="externalPackagingNetweight">
          <el-input v-model.trim="modifyForm.externalPackagingNetweight" @blur="modifyForm.externalPackagingNetweight=externalPackagingNetweightBlur(modifyForm.externalPackagingNetweight,3)" @keyup.native="modifyForm.externalPackagingNetweight=onInput2(modifyForm.externalPackagingNetweight)" clearable></el-input>
        </el-form-item>
        <!-- 产品外包装毛重 externalPackagingGrossweight-->
        <el-form-item v-if="region==='externalPackagingGrossweight'&&isNotEmpty" prop="externalPackagingGrossweight">
          <el-input v-model.trim="modifyForm.externalPackagingGrossweight" @blur="modifyForm.externalPackagingGrossweight=externalPackagingGrossweightBlur(modifyForm.externalPackagingGrossweight,3)" @keyup.native="modifyForm.externalPackagingGrossweight=onInput2(modifyForm.externalPackagingGrossweight)" clearable></el-input>
        </el-form-item>
        <!-- 每层箱数 palletLayerBoxNumber-->
        <el-form-item v-if="region==='palletLayerBoxNumber'&&isNotEmpty" prop="palletLayerBoxNumber">
          <el-input v-model.trim="modifyForm.palletLayerBoxNumber" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
        </el-form-item>
        <!-- 托盘层数 palletLayerNumber-->
        <el-form-item v-if="region==='palletLayerNumber'&&isNotEmpty" prop="palletLayerNumber">
          <el-input v-model.trim="modifyForm.palletLayerNumber" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
        </el-form-item>
        <!-- 托盘上物品长度 palletItemsLength-->
        <el-form-item v-if="region==='palletItemsLength'&&isNotEmpty" prop="palletItemsLength">
          <el-input v-model.trim="modifyForm.palletItemsLength" clearable @blur="modifyForm.palletItemsLength=blurPalletItemsLength(modifyForm.palletItemsLength,2)" @keyup.native="modifyForm.palletItemsLength=onInput(modifyForm.palletItemsLength)"></el-input>
        </el-form-item>
        <!-- 托盘上物品宽度 palletItemsWidth-->
        <el-form-item v-if="region==='palletItemsWidth'&&isNotEmpty" prop="palletItemsWidth">
          <el-input v-model.trim="modifyForm.palletItemsWidth" clearable @blur="modifyForm.palletItemsWidth=blurPalletItemsWidth(modifyForm.palletItemsWidth,2)" @keyup.native="modifyForm.palletItemsWidth=onInput(modifyForm.palletItemsWidth)"></el-input>
        </el-form-item>
        <!-- 托盘上物品高度 palletItemsHeight-->
        <el-form-item v-if="region==='palletItemsHeight'&&isNotEmpty" prop="palletItemsHeight">
          <el-input v-model.trim="modifyForm.palletItemsHeight" clearable @blur="modifyForm.palletItemsHeight=blurPalletItemsHeight(modifyForm.palletItemsHeight,2)" @keyup.native="modifyForm.palletItemsHeight=onInput(modifyForm.palletItemsHeight)"></el-input>
        </el-form-item>
        <!-- 存储高度 storageHeight-->
        <el-form-item v-if="region==='storageHeight'&&isNotEmpty" prop="storageHeight">
          <el-input v-model.trim="modifyForm.storageHeight" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入存储高度"></el-input>
        </el-form-item>
        <!-- 最小DC收货有效期 minimumDcReceivingValidity-->
        <el-form-item v-if="region==='minimumDcReceivingValidity'&&isNotEmpty" prop="minimumDcReceivingValidity">
          <el-input v-model.trim="modifyForm.minimumDcReceivingValidity" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入最小DC收货有效期(天)"></el-input>
        </el-form-item>
        <!-- 是否鲜货 isFresh-->
        <el-form-item v-if="region==='isFresh'&&isNotEmpty" prop="isFresh">
          <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="modifyForm.isFresh" placeholder="请选择是否鲜货"></ic-select>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="onSubmit">确定</el-button>
      <el-button type="primary" @click="onCancel">取消</el-button>
    </el-row>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import { apiService } from "@/api/material/material-master-data";
export default {
  components: {
    IcSelect
  },
  props: ['materialRecordIdList'],
  data() {
    return {
      region: "isConventionalMaterials",
      content: "edit",
      modifyForm: {
        isConventionalMaterials: "",
        dcs: "",
        purchasingManager: "",
        isLto: "",
        approvedBy: "",
        settlementClassification: "",
        useArea: "",
        originCountry: "",
        minimumOrders: "",
        minimumOrderUnit: "",
        isTraceable: "",
        enterCatellaeSystem: "",
        temperature: "",
        validityDate: "",
        minimumStorageTemperature: "",
        maximumStorageTemperature: "",
        dcManagementUnit: "",
        productPackagingType: "",
        externalPackagingLength: "",
        externalPackagingWidth: "",
        externalPackagingHeight: "",
        externalPackagingNetweight: "",
        externalPackagingGrossweight: "",
        palletLayerBoxNumber: "",
        palletLayerNumber: "",
        palletItemsLength: "",
        palletItemsWidth: "",
        palletItemsHeight: "",
        storageHeight: "",
        minimumDcReceivingValidity: "",
        isFresh: "",
      },
      elLists: [
        {
          label: "非常规物料标识",
          value: "isConventionalMaterials",
        },
        {
          label: "DCs",
          value: "dcs",
        },
        {
          label: "是否LTO",
          value: "isLto",
        },
        {
          label: "提交审批人",
          value: "approvedBy",
        },
        {
          label: "结算分类",
          value: "settlementClassification",
        },
        {
          label: "使用区域",
          value: "useArea",
        },
        {
          label: "原产地",
          value: "originCountry",
        },
        {
          label: "最小订单量",
          value: "minimumOrders",
        },
        {
          label: "最小订单单位",
          value: "minimumOrderUnit",
        },
        {
          label: "是否可追溯",
          value: "isTraceable",
        },
        {
          label: "是否进入Catellae系统",
          value: "enterCatellaeSystem",
        },
        {
          label: "储存环境",
          value: "temperature",
        },
        {
          label: "有效期检查",
          value: "validityDate",
        },
        {
          label: "最低保存温度",
          value: "minimumStorageTemperature",
        },
        {
          label: "最高保存温度",
          value: "maximumStorageTemperature",
        },
        {
          label: "DC库存管理单位",
          value: "dcManagementUnit",
        },
        {
          label: "产品外包装类型",
          value: "productPackagingType",
        },
        {
          label: "产品外包装长度(cm)",
          value: "externalPackagingLength",
        },
        {
          label: "产品外包装宽度(cm)",
          value: "externalPackagingWidth",
        },
        {
          label: "产品外包装高度(cm)",
          value: "externalPackagingHeight",
        },
        {
          label: "产品外包装净重(kg)",
          value: "externalPackagingNetweight",
        },
        {
          label: "产品外包装毛重(kg)",
          value: "externalPackagingGrossweight",
        },
        {
          label: "每层箱数",
          value: "palletLayerBoxNumber",
        },
        {
          label: "托盘层数",
          value: "palletLayerNumber",
        },
        {
          label: "托盘上物品长度(cm)",
          value: "palletItemsLength",
        },
        {
          label: "托盘上物品宽度(cm)",
          value: "palletItemsWidth",
        },
        {
          label: "托盘上物品高度(cm)",
          value: "palletItemsHeight",
        },
        {
          label: "存储高度",
          value: "storageHeight",
        },
        {
          label: "最小DC收货有效期(天)",
          value: "minimumDcReceivingValidity",
        },
        {
          label: "是否鲜货",
          value: "isFresh",
        },
      ],
      isConventionalMaterialsLists: [
        {
          label: "Y",
          value: "Y"
        },
        {
          label: "N",
          value: "N"
        },
      ],
      dcsLists: [],
      isLtoLists: [],
      leaderList: [],
      isNotEmpty: true,
      isValid: true
    }
  },
  mounted() {
    console.log('materialRecordIdList', this.materialRecordIdList);
    this.findDcsList()
    this.getLeaderList()
  },
  computed: {
  },
  methods: {
    onBlur(value, num) {
      if (value) {
        var a, b, c, i;
        a = value.toString();
        b = a.indexOf(".");
        c = a.length;
        if (num == 0) {
          if (b != -1) {
            a = a.substring(0, b);
          }
        } else {//如果没有小数bai点
          if (b == -1) {
            a = a + ".";
            for (i = 1; i <= num; i++) {
              a = a + "0";
            }
          } else {//有小数点，超出位数自动截取，否则补0
            a = a.substring(0, b + num + 1);
            for (i = c; i <= b + num; i++) {
              a = a + "0";
            }
          }
        }
        return a;
      }
    },
    onInput(num) {
      var str = num
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      var lenLast = str.substr(str.length - 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1)
      }
      //第一位不能是.
      if (len1 == ".") {
        str = ""
      }
      //最后一位不能是.
      if (str.length == 8 && lenLast == ".") {
        str = ""
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1)
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
      str = (str.match(/^\d*(\.?\d{0,2})/g)[0]) || null
      // 小数点后只能输两位
      return str
      // return this.onBlur(str,2)
    },
    onSubmit() {
      if (!this.region) {
        this.$message.error('请选择字段')
        return false
      }
      if (this.content == 'edit') {
        switch (this.region) {
          case 'isConventionalMaterials':
            if (!this.modifyForm.isConventionalMaterials) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'dcs':
            if (!this.modifyForm.dcs) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'isLto':
            if (!this.modifyForm.isLto) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'approvedBy':
            if (!this.modifyForm.approvedBy) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'settlementClassification':
            if (!this.modifyForm.settlementClassification) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'useArea':
            if (!this.modifyForm.useArea) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'originCountry':
            if (!this.modifyForm.originCountry) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'minimumOrders':
            if (!this.modifyForm.minimumOrders) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'minimumOrderUnit':
            if (!this.modifyForm.minimumOrderUnit) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'isTraceable':
            if (!this.modifyForm.isTraceable) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'enterCatellaeSystem':
            if (!this.modifyForm.enterCatellaeSystem) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'temperature':
            if (!this.modifyForm.temperature) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'validityDate':
            if (!this.modifyForm.validityDate) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'minimumStorageTemperature':
            if (!this.modifyForm.minimumStorageTemperature) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'maximumStorageTemperature':
            if (!this.modifyForm.maximumStorageTemperature) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'dcManagementUnit':
            if (!this.modifyForm.dcManagementUnit) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'productPackagingType':
            if (!this.modifyForm.productPackagingType) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'externalPackagingLength':
            if (!this.modifyForm.externalPackagingLength) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'externalPackagingWidth':
            if (!this.modifyForm.externalPackagingWidth) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'externalPackagingHeight':
            if (!this.modifyForm.externalPackagingHeight) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'externalPackagingNetweight':
            if (!this.modifyForm.externalPackagingNetweight) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'externalPackagingGrossweight':
            if (!this.modifyForm.externalPackagingGrossweight) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'palletLayerBoxNumber':
            if (!this.modifyForm.palletLayerBoxNumber) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'palletLayerNumber':
            if (!this.modifyForm.palletLayerNumber) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'palletItemsLength':
            if (!this.modifyForm.palletItemsLength) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'palletItemsWidth':
            if (!this.modifyForm.palletItemsWidth) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'palletItemsHeight':
            if (!this.modifyForm.palletItemsHeight) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'storageHeight':
            if (!this.modifyForm.storageHeight) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'minimumDcReceivingValidity':
            if (!this.modifyForm.minimumDcReceivingValidity) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
          case 'isFresh':
            if (!this.modifyForm.isFresh) {
              this.isValid = false
            } else {
              this.isValid = true
            }
            break;
        }
      } else {
        this.isValid = true
      }
      if (this.isValid == false) {
        this.$message.error('请填写/选择修改内容.')
      } else {
        if (this.modifyForm.dcs.length !== 0) {
          this.modifyForm.dcs = this.modifyForm.dcs.join(',')
        }
        var changeField = []
        changeField.push(this.region)
        var obj = Object.assign({}, this.modifyForm)
        this.$set(obj, 'materialRecordIdList', this.materialRecordIdList)
        this.$set(obj, 'changeField', changeField)
        apiService.batchModification(obj).then(res => {
          console.log('res', res);
          if (res.code === '200') {
            this.$message.success('修改成功')
            this.onCancel()
          }
        })
      }
    },
    getLeaderList() {
      this.leaderList = []
      var typeList = ['ADMIN', 'NFC', 'SS']
      apiService.categoryLeaderList({ typeList: typeList }).then((res) => {
        console.log('提交审批人', res.data);
        // 去重
        var hash = {}
        this.leaderList = res.data.reduce(function (item, next) {
          hash[next.userName] ? '' : hash[next.userName] = true && item.push(next)
          return item
        }, [])
      });
    },
    findDcsList() {
      apiService.findDcsList().then((res) => {
        if (res.data) {
          //按照id排序
          let arr = res.data
          arr.sort((a, b) => { return a.tmSupplierId - b.tmSupplierId })
          this.dcsLists = arr;
          console.log('dcsLists', this.dcsLists)
        }
      });
    },
    contentChange(e) {
      console.log('e', e);
      if (e === 'empty') {
        this.isNotEmpty = false
        switch (this.region) {
          case 'isConventionalMaterials':
            this.modifyForm.isConventionalMaterials = ''
            break;
          case 'dcs':
            this.modifyForm.dcs = ''
            break;
          case 'isLto':
            this.modifyForm.isLto = ''
            break;
          case 'approvedBy':
            this.modifyForm.approvedBy = ''
            this.modifyForm.purchasingManager = ''
            break;
          case 'settlementClassification':
            this.modifyForm.settlementClassification = ''
            break;
          case 'useArea':
            this.modifyForm.useArea = ''
            break;
          case 'originCountry':
            this.modifyForm.originCountry = ''
            break;
          case 'minimumOrders':
            this.modifyForm.minimumOrders = ''
            break;
          case 'minimumOrderUnit':
            this.modifyForm.minimumOrderUnit = ''
            break;
          case 'isTraceable':
            this.modifyForm.isTraceable = ''
            break;
          case 'enterCatellaeSystem':
            this.modifyForm.enterCatellaeSystem = ''
            break;
          case 'temperature':
            this.modifyForm.temperature = ''
            break;
          case 'validityDate':
            this.modifyForm.validityDate = ''
            break;
          case 'minimumStorageTemperature':
            this.modifyForm.minimumStorageTemperature = ''
            break;
          case 'maximumStorageTemperature':
            this.modifyForm.maximumStorageTemperature = ''
            break;
          case 'dcManagementUnit':
            this.modifyForm.dcManagementUnit = ''
            break;
          case 'productPackagingType':
            this.modifyForm.productPackagingType = ''
            break;
          case 'externalPackagingLength':
            this.modifyForm.externalPackagingLength = ''
            break;
          case 'externalPackagingWidth':
            this.modifyForm.externalPackagingWidth = ''
            break;
          case 'externalPackagingHeight':
            this.modifyForm.externalPackagingHeight = ''
            break;
          case 'externalPackagingNetweight':
            this.modifyForm.externalPackagingNetweight = ''
            break;
          case 'externalPackagingGrossweight':
            this.modifyForm.externalPackagingGrossweight = ''
            break;
          case 'palletLayerBoxNumber':
            this.modifyForm.palletLayerBoxNumber = ''
            break;
          case 'palletLayerNumber':
            this.modifyForm.palletLayerNumber = ''
            break;
          case 'palletItemsLength':
            this.modifyForm.palletItemsLength = ''
            break;
          case 'palletItemsWidth':
            this.modifyForm.palletItemsWidth = ''
            break;
          case 'palletItemsHeight':
            this.modifyForm.palletItemsHeight = ''
            break;
          case 'storageHeight':
            this.modifyForm.storageHeight = ''
            break;
          case 'minimumDcReceivingValidity':
            this.modifyForm.minimumDcReceivingValidity = ''
            break;
          case 'isFresh':
            this.modifyForm.isFresh = ''
            break;
        }
      } else {
        this.isNotEmpty = true
      }
    },
    approvedByChange(e) {
      console.log('e', e);
      this.leaderList.forEach(ele=>{
        if (ele.tmUserId===e) {
          this.modifyForm.purchasingManager=ele.userName
        }
      })
    },
    onCancel() {
      this.modifyForm = {
        region: "",
        purchasingManager: "",
        content: "",
        isConventionalMaterials: "",
        dcs: "",
        isLto: "",
        approvedBy: "",
        settlementClassification: "",
        useArea: "",
        originCountry: "",
        minimumOrders: "",
        minimumOrderUnit: "",
        isTraceable: "",
        enterCatellaeSystem: "",
        temperature: "",
        validityDate: "",
        minimumStorageTemperature: "",
        maximumStorageTemperature: "",
        dcManagementUnit: "",
        productPackagingType: "",
        externalPackagingLength: "",
        externalPackagingWidth: "",
        externalPackagingHeight: "",
        externalPackagingNetweight: "",
        externalPackagingGrossweight: "",
        palletLayerBoxNumber: "",
        palletLayerNumber: "",
        palletItemsLength: "",
        palletItemsWidth: "",
        palletItemsHeight: "",
        storageHeight: "",
        minimumDcReceivingValidity: "",
        isFresh: "",
      }
      this.$emit('closeDialog')
    }
  }
}
</script>